import { parseIntBase64 } from '@bingads-webui-universal/primitive-utilities';

export function parseCompactedKeywords(selectedKeywordIds, matchTypes) {
  const matchTypeValues = {
    Exact: 1,
    Phrase: 2,
    Broad: 3,
    Content: 5,
    Predictive: 9,
  };
  const keywords = [];

  if (selectedKeywordIds && selectedKeywordIds.length > 0) {
    const keywordGroups = selectedKeywordIds.split(';');

    keywordGroups.forEach((group, index) => {
      if (group.length > 0) {
        const biddedMatchType = matchTypeValues[matchTypes[index]];
        group.split(',').forEach((item) => {
          keywords.push({
            KeywordId: parseIntBase64(item),
            BiddedMatchType: biddedMatchType,
          });
        });
      }
    });
  }

  return keywords;
}

export const getTargetEntity = (event, view) => {
  const key = view.keyOfElement(event.target);

  return view.itemWithKey(key);
};
